var React = require('react');
var ReactDOM = require('react-dom');
var _ = require('underscore');
var $ = require('jquery');

var T = React.PropTypes;

var PositionContainer = React.createClass({
    propTypes: {
        
        /**
         * 指定定位的方位
         */
        at: T.oneOf(['left top', 'left bottom', 'right top', 'right bottom']),
        
        /**
         * 指定 z-index
         */
        zIndex: T.number,
        
        /**
         * 指定定位的偏移量
         */
        offset: T.shape({ x: T.number, y: T.number })
        
    },
    getDefaultProps(){
        return {
            at: "right top",
            zIndex: 9000,
            offset: { x: 150, y: 80 }
        }
    },
    /**
     * 获取方位对应的 offset
     * @param {String} 定位的方位
     * @param {Object} 偏移量
     * @return { Number } 对应的偏移量
     * @private
     */
    _getOffsetFromAtPos(at,offset){
        
        switch (at){
            
            case 'left':
            case 'right':    
                
                return offset.x
            
            case 'top':
            case 'bottom':
                
                return offset.y
        }
        
    },
    /**
     * 设置容器定位
     * @private
     */
    _setPos(el){
        
        var atPos = this.props.at.split(' ');
        var offset = this.props.offset;

        el = $(el);
        
        
        el.css({
            position :'fixed',
            zIndex: this.props.zIndex
        });

        _.each(atPos, (at)=>{
            el.css( at,this._getOffsetFromAtPos( at, offset )); 
        });

        
    },
    componentDidMount(){

        var className = 'mod-gin-notify-container';
        var containerEl = document.querySelector('.'+className);


        if( ! containerEl ){

            containerEl = document.createElement('div');

            $(containerEl).addClass(className);
            this._setPos( containerEl );

            document.body.appendChild( containerEl );

        }

        this.containerElement = containerEl;

        this.componentDidUpdate();


    },
    componentDidUpdate(){

        ReactDOM.render( <div>{this.props.children}</div>, this.containerElement )

    },
    
    render(){
        return null
    }
    
});

module.exports = PositionContainer;



/** WEBPACK FOOTER **
 ** ./script/cutil/gin-notify/position-container.jsx
 **/